import type { RouteObject } from 'react-router'

import { PortfolioPage } from '@/features/portfolio/PortfolioPage'

export const routes: RouteObject[] = [{ path: 'portfolio', element: <PortfolioPage /> }]
